import { MessageSchema } from "@redotech/redo-model/agents/llm-messages";
import * as z from "zod";

export const sendContextualOnboardingMessage = {
  name: "sendContextualOnboardingMessage" as const,
  input: z.object({
    messages: z.array(MessageSchema),
    currentStepId: z.string(),
    currentConfig: z.record(z.string(), z.any()),
  }),
  output: z.object({ messages: z.array(MessageSchema) }),
};
